import React from 'react';

import Plugin from './src';

export default props => <Plugin {...props} />;
